import { currentStep, STEPS } from "../../../store";
import {useSelector} from "react-redux";
import clsx from "clsx";
import './Stepper.scss';

export const Stepper = () => {

  const step = useSelector(currentStep);
  const currentIndex = STEPS.indexOf(step);

  return (
    <div className="stepper">
      {
        STEPS.map((_, index: number) =>
          <span className={clsx('item', { 'active': index <= currentIndex })} key={index} />
        )
      }
    </div>
  )
}